<template>
  <div>
    <div class="height-45 s_flex_bian_c width100">
      <div class="height-45 s_flex_center width50 fz-14" :class='active == 1 ? "s_bf054 tw-text-white":"s_bf"'
        @click='active = 1'>商品信息</div>
      <div class="height-45 s_flex_center width50 fz-14" :class='active == 2 ? "s_bf054 tw-text-white":"s_bf"'
        @click='active = 2'>物流码信息</div>
    </div>
    <div class="m-t-10" v-if='active == 1'>
      <van-field v-model="form.refund_warehousing_sn" name="warehousing_sn" label="退货单号：" readonly />
      <van-field v-model="form.to" name="warehousing_sn" label="退货人：" readonly />
      <van-field v-model="form.refund_warehouse_name" name="refund_warehouse_name" label="退货仓库：" readonly />
      <van-field v-model="form.create_time" name="warehousing_sn" label="创建时间：" readonly class="m-b-10" />
      <van-field class="m-t-10" label="商品信息" readonly />
      <div class="tw-bg-white p-l-15 p-r-15 m-b-10" v-for="(v,k) in form.product" :key="k">
        <van-card class="tw-bg-white" :thumb="info.oss_domain+v.product_image">
          <template #title>
            <p class="fz-15 s_omit">{{v.product_name}}</p>
          </template>
          <template #desc>
            <p class="tw-text-gray-400 s_lin_h22">{{v.product_sku_name || '单规格'}}</p>
            <p class="tw-text-gray-400 s_lin_h22">商品编号：{{v.product_sn}}</p>
          </template>
        </van-card>
        <van-divider :style="{ margin: '0' }"/>
        <van-field style="padding-left: 0;padding-right: 0;" v-model="v.refund_warehousing_num" name="refund_warehousing_num" label="
        退货数量：" readonly />
      </div>
    </div>
    <div class="m-t-10" v-if='active == 2'>
      <van-search v-model="search.keyword" show-action placeholder="请输入物流码进行搜索">
        <template #action>
          <div class="height-34 s_flex_center s_bf054 width-55 tw-text-white tw-rounded-sm" @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="p-15 s_bf" v-if='list.length'>
        <div class="s_flex_bian_c s_bf5 height-40 tw-border tw-border-gray-200 tw-border-solid tw-bg-gray-300 tw-bg-opacity-30">
          <p class="width33 s_flex_center">物流码</p>
          <p class="width33 s_flex_center">码类型</p>
          <p class="width33 s_flex_center">商品数量</p>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model:loading="loading" :finished="finished" :immediate-check='false' finished-text="我也是有底线的~" @load="onLoad">
            <div class="s_flex_bian_c height-40 tw-border tw-border-gray-200 tw-border-solid tw-border-t-0 s_bf"
              v-for="(item,index) in list" :key='index'>
              <p class="tw-text-center width33">{{item.code_sn}}</p>
              <p class="tw-text-center width33">{{item.code_type_text}}</p>
              <p class="tw-text-center width33">{{item.code_num}}</p>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <van-empty v-if="!list.length" :image="require('@/assets/image/empty.png')" description="暂无物流码" />
    </div>
  </div>
</template>

<script>
import { normalizeQrCode } from '@/utils/qrCode';
  import { ref, onMounted, inject, reactive, toRefs, computed } from "vue";
  import { getRefundWarehouseMore, getRefundWarehousingCode } from '@/api/refundWarehouse'
  import { useRoute } from 'vue-router';
  import { iscode } from '@/utils/app'
  import store from '@/store'
  import { Toast } from "vant";
  import { SplitArray } from "@/utils/util";
  let defForm = {
    warehousing_sn: "",
    warehouse_id: null,
    position_id: null,
    use_product_batch: 0,
    product_batch_id: "",
    product_id: "",
    product_sku_sn: "",
    scan_type: 1,
    code_sn: "",
  };
  export default {
    setup() {
      const form = ref({ ...defForm });
      const info = computed({
        get() {
          return store.state.user.info
        }
      })
      const search = ref({
        page: 1,
        limit: 20,
        keyword: "",
      });
      const state = reactive({
        active: 1,
        list: [],
        loading: false, // 是否处于加载状态，加载过程中不触发 load 事件
        finished: false, // 是否已加载完成，加载完成后不再触发 load 事件
        refreshing: false, // 是否处于加载中状态
      });
      const route = useRoute()
      const initData = async () => {
        // 详情
        let result = await getRefundWarehouseMore(route.query.refund_sn).then(res => res.data)
        if (iscode(result)) {
          form.value = result.data
        } else {
          iscode(result, true)
        }

      }
      const getCode = async () => {
        search.value.keyword = normalizeQrCode(search.value.keyword);
        // 物流码信息
        if (state.finished && state.loading) return;
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        let result = await getRefundWarehousingCode({ ...search.value,refund_sn: route.query.refund_sn}).then(res => res.data).catch(error => error)
        Toast.clear();
        if (iscode(result)) {
          var listData = result.data || [];
          var list = SplitArray(listData, state.list);
          var finished = listData.length < search.value.limit;
          state.list = list;
          state.finished = finished;
          state.loading = false;
        } else {
          Toast.fail(result.msg);
        }
      }
      // 上拉加载
      const onLoad = () => {
        search.value.page = search.value.page + 1;
        getCode();
      };
      //下拉刷新
      const onRefresh = () => {
        state.finished = false;
        state.list = [];
        search.value = { ...search.value, page: 1 };
        getCode();
      };
      const onSearch = (e) => {
        onRefresh();
      };
      onMounted(() => {
        initData()
        getCode()
      });

      return {
        ...toRefs(state),
        form,
        info,
        getCode,
        search,
        onRefresh,
        onLoad,
        onSearch
      };
    },
  };
</script>
